import GroupMatches from './GroupMatches';

export default GroupMatches;
